import RouteError from '@/components/ui/route-error';
import { createFileRoute } from '@tanstack/react-router';
import DashboardRouteLayout from '@/app/components/dashboard-route-layout';
import DashboardPlaceholder from '@/app/components/dashboard-placeholder';
import { DICTIONARY } from '@/config/dictionary';
import { requireAuth } from '@/utils/require-auth-before-load';

const DashboardNumbersPage = () => {
  return (
    <DashboardRouteLayout>
      <DashboardPlaceholder title={DICTIONARY.dashboard.navigation.numbers} />
    </DashboardRouteLayout>
  );
};

export const Route = createFileRoute('/numbers')({
  beforeLoad: requireAuth,
  component: DashboardNumbersPage,
  errorComponent: RouteError,
});
